import { Box, Typography } from '@mui/material'
import { styled } from '@mui/system'

export const FooterContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: '2rem',
    backgroundColor: theme.palette.secondary.main,
    boxSizing: 'border-box',
    zIndex: 100,
    [theme.breakpoints.down('sm')]: {
        padding: '1.5rem 1rem',
    },
}))

export const FooterLogoContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '1.5rem',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: '0.5rem',
    },
}))

export const FooterLogo = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    '& img': {
        width: '50px',
        height: 'auto',
        borderRadius: '5px',
    },
}))

export const DividerLine = styled('div')(({ theme }) => ({
    flex: 1,
    height: '1px',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    margin: '0 1.5rem',
    [theme.breakpoints.down('sm')]: {
        width: '80%',
        margin: '0.5rem 0',
    },
}))

export const SocialMediaIcons = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0.25rem',
    flexShrink: 0,
    '& .MuiIconButton-root': {
        color: 'white',
        padding: '8px',
        '&:hover': {
            color: theme.palette.info.main,
        },
    },
    '& svg': {
        fontSize: '1.4rem',
    },
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
    },
}))

export const FooterColumns = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '2rem',
    width: '100%',
    maxWidth: '1200px',
    padding: '1rem 0',
    [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '1.5rem',
    },
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
        gap: '1.5rem',
        textAlign: 'center',
    },
}))

export const Column = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    '& h6': {
        marginBottom: '0.75rem',
        color: 'white',
        fontWeight: 600,
        fontSize: '1rem',
    },
    '& a': {
        color: 'rgba(255, 255, 255, 0.7)',
        textDecoration: 'none',
        marginBottom: '0.4rem',
        fontSize: '0.9rem',
        transition: 'color 0.2s',
        '&:hover': {
            color: theme.palette.info.main,
        },
    },
    [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
    },
}))

export const FooterTypography = styled(Typography)(({ theme }) => ({
    color: 'rgba(255, 255, 255, 0.7)',
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.9rem',
    marginBottom: '0.4rem',
    '& svg': {
        fontSize: '1.1rem',
        marginRight: '6px',
        flexShrink: 0,
    },
    '& a': {
        color: 'rgba(255, 255, 255, 0.7)',
        textDecoration: 'none',
        '&:hover': {
            color: theme.palette.info.main,
        },
    },
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
    },
}))
